// extracted by mini-css-extract-plugin
export default {"meal":"MealItem_meal__MZePC","description":"MealItem_description__3xceu","price":"MealItem_price__73xmG"};